<template>
  <CCard class="dataTable py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize">
            {{ $t('sender.domainSender.domainSenderList.header1') }}
          </h2>
        </div>
      </CCol>
    </CRow>
    <CCardHeader
      class="dataTable__header d-flex justify-content-between px-0 pb-5"
      v-if="totalRecords > 0 || tableFilterValue != null || filterDomain"
    >
      <div class="dataTable__countContants">
        <h3 class="font-weight-normal text-warning mt-3 d-flex align-items-sm-center">
          <CIcon name="pending" class="text-warning mx-2" size="custom-size" :height="30" viewBox="0 0 32 32" />
          {{ totalPendings || 0 }}
          <span class="font-xs font-weight-normal text-uppercase ml-2">{{ $t('sender.domainSender.domainSenderList.text.peddingOrders') }}</span>
        </h3>
      </div>
      <div class="dataTable__search">
        <CInput
          type="search"
          maxlength="50"
          :placeholder="$t('sender.domainSender.input-search.placeholder')"
          addInputClasses="pl-5"
          class="iconSearchPlaceholder pb-0"
          v-model="tableFilterValue"
        ></CInput>
      </div>
      <div class="dataTable__buttonLink">
        <router-link
          v-if="hasSessionPermission('Sender_Create')"
          class="btn btn-primary px-4 py-3 font-weight-bold"
          tag="button"
          :to="{ name: 'new-senders-domain' }"
          >{{ $t('sender.domainSender.domainSenderList.button.newSender') }}</router-link
        >
      </div>

      <!-- <button @click="testeAcc">acc</button> -->
    </CCardHeader>
    <div class="mx-auto" @click="navigateToDomainHelpDocs">
      <CAlert class="mb-2" color="info">
        <div class="d-flex align-items-baseline">
          <div>
            <CIcon name="infoCircle" size="custom-size" class="mr-2" :height="16" style="transform: rotate(180deg)" viewBox="0 0 32 32" />
          </div>
          <p class="font-weight-semibold mb-0 text-center text-underline cursor-pointer">{{ $t('sender.domainSender.help') }}</p>
        </div>
      </CAlert>
    </div>
    <template v-if="totalRecords == 0 && tableFilterValue == null && filterDomain == false">
      <EmptyList
        :loading="loadingGetList"
        :linkText="$t('sender.domainSender.domainSenderList.button.newSender')"
        :linkTo="{ name: 'new-senders-domain' }"
        :title="$t('sender.domainSender.domainSenderList.text.noSenders')"
        :subTitle="$t('sender.domainSender.domainSenderList.text.newSender')"
      />
    </template>
    <template v-if="totalRecords > 0 || tableFilterValue != null || filterDomain">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>

      <!-- 1: 'pending configuration',
        2: 'pending verification',
        3: 'authenticated',
        4: 'unauthenticate',
        5: 'authenticated',
        6: 'unauthenticate' -->

      <HeaderActions
        :show="{
          checkItems: true,
          approveRefuse: false,
          associate: this.showAssociate,
          manage: false,
          filterBy: true,
          delete: this.showDelete,
        }"
        :showApproveRefuse="showApproveRefuse"
        :loadingSenderRequest="loadingSenderRequest"
        :multiSelect="false"
        :itemsListSelected="Boolean(itemsListSelected)"
        :filterByData="[
          { column: 'OrganizationStatusId', value: 1, label: $t('sender.domainSender.domainSenderList.filterByState.active') },
          { column: 'OrganizationStatusId', value: 2, label: $t('sender.domainSender.domainSenderList.filterByState.inactive') },
          { column: 'SenderStatusId', value: 1, label: $t('sender.domainSender.domainSenderList.filterByState.pending-configuration') },
          { column: 'SenderStatusId', value: 2, label: $t('sender.domainSender.domainSenderList.filterByState.pending-verification') },
        ]"
        :confirmationDeleteDescription="$t('sender.domainSender.delete.description')"
        @confirm="deleteItemsSelected"
        @filterBy="chooseFilterBy"
        @approveOrReprove="approveOrReprove"
      />

      <CCardBody class="dataTable__body p-0">
        <CDataTable
          :items="registers"
          :fields="headers"
          :table-filter="{ external: true, lazy: true }"
          :table-filter-value.sync="tableFilterValue"
          items-per-page-select
          @row-clicked="(item) => check(item)"
          :items-per-page.sync="itemsPerPage"
          @pagination-change="paginationChange"
          :active-page="1"
          hover
          :loading="loading"
        >
          <template #loading>
            <div class="d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
          </template>

          <template #select="{ item }">
            <td>
              <CInputRadio name="check" class="text-center checkboxTable" :checked="item._selected" custom />
            </td>
          </template>

          <template #showDetails="{ item, index }">
            <td class="text-center" @click="toggleDetails(item, index)">
              <span>
                <u class="text-uppercase">{{ $t('general.table.header.details') }}</u>
                <CIcon name="arrow" class="mx-1" size="custom-size" :height="15" viewBox="0 0 32 32" />
              </span>
            </td>
          </template>

          <template #details="{ item }">
            <CCollapse :show="Boolean(item._toggled)" class="bg-gray-200 text-gray-600">
              <template v-if="item.statusId == 1">
                <!--PENDING_CONFIGURATION -->

                <CCol class="py-5 px-4">
                  <CRow class="d-flex justify-content-between">
                    <CCol sm="12" md="7" class="d-flex align-self-start">
                      <div>
                        <CIcon
                          :name="statusOrderClass(item.statusId)"
                          :class="statusOrderClass(item.statusId)"
                          class="mr-2"
                          size="custom-size"
                          :height="20"
                          viewBox="0 0 32 32"
                        />
                      </div>
                      <div>
                        <h6 class="text-uppercase font-weight-normal mb-2 mt-1">
                          {{ $t('sender.domainSender.domainSenderList.status.peding-configuration') }}
                        </h6>
                        <p class="m-0">
                          {{ $t('sender.domainSender.domainSenderList.status.message-notified') }}
                        </p>
                      </div>
                    </CCol>
                    <CCol sm="12" md="3">
                      <h6 class="text-uppercase font-weight-normal mb-2">{{ $t('sender.domainSender.domainSenderList.table.request-date') }}</h6>
                      <p class="m-0">
                        {{ formatDate(item.requestDatetime) }}
                      </p>
                    </CCol>
                  </CRow>
                </CCol>
              </template>

              <template v-if="item.statusId >= 2">
                <!--PENDING_VERIFICATION -->
                <ul class="d-flex listItem__detail pl-0 pt-4 mb-0">
                  <li class="col-md-12 mb-4">
                    <div class="d-flex align-items-center">
                      <CIcon
                        :name="statusOrderDoamin(item.dkimStatus)"
                        :class="statusOrderDoamin(item.dkimStatus)"
                        class="mx-2"
                        size="custom-size"
                        :height="19"
                        viewBox="0 0 32 32"
                      />
                      <span class="text-uppercase text-gray-base">{{ $t('sender.domainSender.domainSenderList.table.terms.dkim') }}</span>
                    </div>
                    <div>
                      <div class="pl-5">
                        <div class="mb-3">
                          <p class="text-uppercase text-decoration block m-0">
                            {{ $t('sender.domainSender.domainSenderList.table.terms.name-host') }}
                          </p>

                          <div class="d-flex align-content-center clip font-xs" title="copy" :data-clipboard-text="item.nameHost">
                            <span style="word-break: break-all">{{ item.nameHost }}</span>
                            <p class="m-0 pl-3 d-flex align-self-start">
                              <CIcon class="btn-values" name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
                            </p>
                          </div>
                        </div>
                        <div class="mb-3">
                          <p class="text-uppercase text-decoration block m-0">
                            {{ $t('sender.domainSender.domainSenderList.table.terms.type') }}
                          </p>

                          <span class="clip font-xs">TXT</span>
                        </div>
                        <div>
                          <p class="text-uppercase text-decoration block m-0">{{ $t('sender.domainSender.domainSenderList.table.terms.value') }}</p>
                          <div class="d-flex flex-column align-content-center clip font-xs" title="copy" :data-clipboard-text="item.value">
                            <div class="d-flex align-content-center">
                              <span style="word-break: break-all">{{ item.value }}</span>

                              <p class="m-0 pl-3 d-flex align-self-start">
                                <CIcon class="btn-values" title="copiar" name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-column align-content-center clip pl-5 font-xs" title="copy" :data-clipboard-text="item.value"></div>
                  </li>
                  <li class="col-md-12 mb-4">
                    <div class="d-flex align-items-center">
                      <CIcon
                        :name="statusOrderDoamin(item.spfStatus)"
                        :class="statusOrderDoamin(item.spfStatus)"
                        class="mx-2"
                        size="custom-size"
                        :height="19"
                        viewBox="0 0 32 32"
                      />
                      <span class="text-uppercase text-gray-base">{{ $t('sender.domainSender.domainSenderList.table.terms.spf') }} </span>
                    </div>
                    <div>
                      <div class="pl-5">
                        <div class="mb-3">
                          <p class="text-uppercase text-decoration block m-0">
                            {{ $t('sender.domainSender.domainSenderList.table.terms.name-host') }}
                          </p>
                          <span class="clip font-xs">@</span>
                        </div>
                        <div class="mb-3">
                          <p class="text-uppercase text-decoration block m-0">
                            {{ $t('sender.domainSender.domainSenderList.table.terms.type') }}
                          </p>

                          <span class="clip font-xs">TXT</span>
                        </div>
                        <p class="text-uppercase text-decoration block m-0">{{ $t('sender.domainSender.domainSenderList.table.terms.value') }}</p>
                        <div class="d-flex align-content-center clip font-xs" title="copy" :data-clipboard-text="item.spfRecord">
                          <span style="word-break: break-all">{{ item.spfRecord }}</span>
                          <p class="m-0 pl-3 d-flex align-self-start">
                            <CIcon class="btn-values" title="copiar" name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-column align-content-center clip pl-5 font-xs" title="copy" :data-clipboard-text="item.value"></div>
                  </li>
                  <li class="col-md-12 mb-4">
                    <div class="d-flex align-items-center">
                      <CIcon
                        :name="statusOrderDoamin(item.ownerShipTokenStatus)"
                        :class="statusOrderDoamin(item.ownerShipTokenStatus)"
                        class="mx-2"
                        size="custom-size"
                        :height="19"
                        viewBox="0 0 32 32"
                      />
                      <span class="text-uppercase text-gray-base">
                        {{ $t('sender.domainSender.domainSenderList.table.terms.owner-ship-token') }}</span
                      >
                    </div>
                    <div class="pl-5">
                      <div class="mb-3">
                        <p class="text-uppercase text-decoration block m-0">
                          {{ $t('sender.domainSender.domainSenderList.table.terms.name-host') }}
                        </p>

                        <div class="d-flex align-content-center clip font-xs" title="copy" :data-clipboard-text="item.ownerShipTokenRecordName">
                          <span style="word-break: break-all">{{ item.ownerShipTokenRecordName }}</span>
                          <p class="m-0 pl-3 d-flex align-self-start" v-if="item.ownerShipTokenRecordName">
                            <CIcon class="btn-values" name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
                          </p>
                        </div>
                      </div>
                      <div class="mb-3">
                        <p class="text-uppercase text-decoration block m-0">
                          {{ $t('sender.domainSender.domainSenderList.table.terms.type') }}
                        </p>

                        <span class="clip font-xs">TXT</span>
                      </div>
                      <div>
                        <p class="text-uppercase text-decoration block m-0">
                          {{ $t('sender.domainSender.domainSenderList.table.terms.value') }}
                        </p>
                        <div class="d-flex flex-column align-content-center clip font-xs" title="copy" :data-clipboard-text="item.ownerShipToken">
                          <div class="d-flex align-content-center">
                            <span style="word-break: break-all">{{ item.ownerShipToken }}</span>

                            <p class="m-0 pl-3 d-flex align-self-start" v-if="item.ownerShipToken">
                              <CIcon class="btn-values" title="copiar" name="copy" size="custom-size" :height="19" viewBox="0 0 32 32" />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="col-md-12 mb-4">
                    <div class="d-flex align-items-center">
                      <CIcon name="question" class="mx-2" size="custom-size" :height="19" viewBox="0 0 32 32" />
                      <p class="m-0 text-uppercase text-gray-base">{{ $t('sender.domainSender.domainSenderList.table.terms.dmarc.title') }}</p>
                    </div>
                    <div>
                      <div class="pl-5">
                        <p>
                          {{ $t('sender.domainSender.domainSenderList.table.terms.dmarc.text-1') }}<br />
                          {{ $t('sender.domainSender.domainSenderList.table.terms.dmarc.text-2') }}<br />
                          <span class="font-weight-bold">{{ $t('sender.domainSender.domainSenderList.table.terms.dmarc.text-3') }}</span
                          ><br />
                          {{ $t('sender.domainSender.domainSenderList.table.terms.dmarc.text-4') }}<br />
                          <a
                            class="text-underline"
                            href="https://blog.sendit.pt/novas-regras-de-autenticacao-do-gmail-e-yahoo-para-2024/"
                            target="_blank"
                            >{{ $t('sender.domainSender.domainSenderList.table.terms.dmarc.text-5') }}</a
                          >
                        </p>
                      </div>
                    </div>
                  </li>
                  <li class="col-md-3 mb-3 pl-5">
                    <div class="d-flex align-items-center">
                      <span class="text-uppercase">{{ $t('sender.domainSender.domainSenderList.table.request-date') }}</span>
                    </div>
                    {{ formatDate(item.requestDatetime) }}
                  </li>
                  <li class="col-md-3 mb-3 pl-5">
                    <div class="d-flex align-items-center">
                      <span class="text-uppercase">
                        {{ $t('sender.domainSender.domainSenderList.table.reply-date') }}
                      </span>
                    </div>
                    {{ formatDate(item.answerDatetime) }}
                  </li>
                  <li class="col-md-12 mb-4">
                    <CAlert color="warning" v-if="item.statusId != 3">
                      {{ $t('sender.domainSender.domainSenderList.table.notification-sender') }}
                    </CAlert>
                    <CButton
                      v-if="item.statusId != 3"
                      @click="submitAuthentication(item.requestingOrganizationId, item.domainSenderRequestId)"
                      :class="buttonAuthenticationClicked ? 'disabled' : false"
                      class="btn btn-primary"
                    >
                      {{ $t('sender.domainSender.domainSenderList.table.buttom.authenticate') }}
                    </CButton>
                  </li>
                </ul>
              </template>
            </CCollapse>
          </template>

          <template #organizationSender.isActive="{ item }">
            <td>
              <span :class="{ active: item.organizationDomainSender.isActive }" class="text-capitalize">{{
                statusOrganization(item.organizationDomainSender.isActive)
              }}</span>
            </td>
          </template>

          <template #answerOrganizationUserId="{ item }">
            <td>
              <span>{{ item.answerOrganizationUserId || '' }}</span>
            </td>
          </template>

          <template #organizationSender.statusId="{ item }">
            <td>
              <span class="text-uppercase d-flex align-items-center">
                <CIcon
                  :name="statusOrderClass(item.statusId)"
                  :class="statusOrderClass(item.statusId)"
                  class="mx-2"
                  size="custom-size"
                  :height="19"
                  viewBox="0 0 32 32"
                />
                <span>{{ statusOrder(item.statusId) }}</span>
              </span>
            </td>
          </template>
        </CDataTable>
      </CCardBody>

      <CPagination
        v-show="pages > 0 && totalRecords > 0"
        align="center"
        :pages="pages"
        :active-page.sync="activePage"
        class="dataTable__newPagination mt-3"
      >
        <template slot="previous-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.prev') }}
          </span>
        </template>
        <template slot="next-button">
          <span class="newPagination__button p-2 btnPagination">
            {{ $t('audience.audienceList.text.next') }}
          </span>
        </template>
      </CPagination>
    </template>
  </CCard>
</template>

<script>
import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'
import EmptyList from '@/components/EmptyList'
import services from '@/services.js'
import ClipboardJS from 'clipboard'
import { mapGetters } from 'vuex'

export default {
  name: 'SendersDomainList',
  components: {
    MenssageAlert,
    HeaderActions,
    EmptyList,
  },
  data() {
    return {
      showApproveRefuse: false,
      loadingSenderRequest: false,
      loadingGetList: false,
      columnFilterValue: {},
      tableFilterValue: null,
      loadedItems: [],
      loading: false,
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      totalPendings: 0,
      totalRecords: 0,
      itemsListSelected: null,
      activePage: 1,
      responsive: false,
      messages: [],
      SenderStatusId: null,
      OrganizationStatusId: null,
      collapseDuration: 0,
      details: [],
      indexItemOpened: null,
      domainNameHost: '',
      domainValue: '',
      reasonTextRefuse: '',
      statePopUpRefuseSenderDomain: false,
      customModalRefuse: false,
      defaultReasonRefuse: false,
      buttonAuthenticationClicked: false,
      buttonConfigurationClicked: false,
      statePopUpUnauthenticateSenderDomain: false,
      customModalUnauthenticate: false,
      reasonTextUnauthenticate: '',
      defaultReasonUnauthenticate: false,
      intervalTime: '',
      intervalValue: '',
      pagination: [],
    }
  },

  created() {
    this.loadingGetList = true
    this.getData({
      page: this.activePage,
      count: this.itemsPerPage,
      Domain: this.tableFilterValue,
      SenderStatusId: this.SenderStatusId,
      OrganizationStatusId: this.OrganizationStatusId,
    })
  },

  mounted() {
    this.$root.$on('approveOrReprove', (obj) => {
      this.approveOrReprove(obj)
    })

    this.organizationId()
    this.setTypeSender()

    var clipboard = new ClipboardJS('.clip')

    clipboard.on('success', function (e) {
      e.clearSelection()
    })

    this.reloadTable()
  },

  beforeDestroy() {
    clearInterval(this.intervalTime)
  },

  watch: {
    reloadParams() {
      this.onTableChange()
    },

    lang(newLang, oldLang) {
      if (newLang) {
        this.onTableChange()
      }
    },
  },

  computed: {
    ...mapGetters({
      hasSessionPermission: 'auth/hasSessionPermission',
    }),

    lang() {
      return this.$store.state.lang
    },

    filterDomain() {
      return this.SenderStatusId != null || this.OrganizationStatusId != null
    },
    registers() {
      return this.loadedItems.map((sender) => {
        if (this.itemsListSelected == sender.domainSenderRequestId) {
          this.$store.dispatch(
            'senders/setIdSender',
            //sender.organizationDomainSender.id
            sender.organizationDomainSender.organizationDomainSenderId,
          )
        }

        return {
          ...sender,
          _selected: this.itemsListSelected == sender.domainSenderRequestId,
          _classes: [sender._classes, (sender._selected = this.itemsListSelected == sender.domainSenderRequestId ? 'table-selected' : '')],
        }
      })
    },

    itemsPending() {
      return 0
      // return this.loadedItems.find(item => item.statusIdto == 1)
    },

    showApproveRefuse() {
      // só mostra a featuea de aprovação se  status por pedding
      const item = this.loadedItems.find((item) => item.domainSenderRequestId == this.itemsListSelected) || null
      return item ? item.statusId == 1 : null // 1 == pedding
    },

    showAssociate() {
      // só mostra a feature de associaçao se  status por approved
      const item = this.loadedItems.find((item) => item.domainSenderRequestId == this.itemsListSelected) || null
      return item ? item.statusId == 3 : null // 2 == approved
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage, this.tableFilterValue, this.SenderStatusId, this.OrganizationStatusId, this.intervalValue]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  of ${this.totalRecords}`
    },

    showDelete() {
      return this.hasSessionPermission('Sender_Delete')
    },
  },

  methods: {
    reloadTable() {
      this.intervalTime = setInterval(() => {
        if (!this.loading)
          this.getData(
            {
              page: this.activePage,
              count: this.itemsPerPage,
              Domain: this.tableFilterValue,
              SenderStatusId: this.SenderStatusId,
              OrganizationStatusId: this.OrganizationStatusId,
            },
            false,
          )
      }, this.$configs.VUE_APP_TIME_TABLE || 10000)
    },

    configureSenderDomain(senderRequestId) {
      this.buttonConfigurationClicked = true
      this.messages = []
      let body = {
        status: 2, //to submit
        reasonText: null,
        value: this.domainValue,
        nameHost: this.domainNameHost,
      }
      let organizationId = this.$store.state.auth.organizationId
      services
        .configureSenderDomain(organizationId, senderRequestId, body)
        .then((senders) => {})
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || 'Erro',
          })
        })
        .finally(() => {
          this.domainValue = ''
          this.domainNameHost = ''
          this.buttonConfigurationClicked = false
          this.onTableChange()
        })
    },

    refuseDomain(senderRequestId) {
      this.messages = []
      let body = {
        status: 3, //refused
        reasonText: this.reasonTextRefuse,
        value: null,
        nameHost: null,
      }

      let organizationId = this.$store.state.auth.organizationId

      services
        .configureSenderDomain(organizationId, senderRequestId, body)
        .then((senders) => {})
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || 'Erro',
          })
        })
        .finally(() => {
          this.domainValue = ''
          this.domainNameHost = ''
          this.closeCustomReasonRefuse()
          this.onTableChange()
        })
    },

    unauthenticateDomain(senderRequestId) {
      this.messages = []
      let body = {
        status: 6, //unauthenticated
        reasonText: this.reasonTextUnauthenticate,
      }
      let organizationId = this.$store.state.auth.organizationId
      services
        .authenticateSenderDomain(organizationId, senderRequestId, body)
        .then((senders) => {})
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || 'Erro',
          })
        })
        .finally(() => {
          this.domainValue = ''
          this.domainNameHost = ''
          this.closeCustomUnauthenticate()
          this.onTableChange()
        })
    },

    authenticateDomain(senderRequestId) {
      this.messages = []
      let body = {
        status: 5,
      }
      let organizationId = this.$store.state.auth.organizationId
      services
        .authenticateSenderDomain(organizationId, senderRequestId, body)
        .then((senders) => {})
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.Message || 'Erro',
          })
        })
        .finally(() => {
          this.domainValue = ''
          this.domainNameHost = ''
          this.onTableChange()
        })
    },

    closeCustomReasonRefuse() {
      this.statePopUpRefuseSenderDomain = false
      this.customModalRefuse = false
      this.reasonTextRefuse = ''
    },

    closeCustomUnauthenticate() {
      this.statePopUpUnauthenticateSenderDomain = false
      this.customModalUnauthenticate = false
      this.reasonTextUnauthenticate = ''
    },

    openCustomReasonRefuse() {
      this.defaultReasonRefuse = false
      this.customModalRefuse = true
    },

    openCustomReasonUnauthenticate() {
      this.defaultReasonUnauthenticate = false
      this.customModalUnauthenticate = true
    },

    setReason(reason) {
      this.reasonTextRefuse = reason
      this.defaultReasonRefuse = true
      this.customModalRefuse = true
    },

    setReasonUnauthenticate(reason) {
      this.reasonTextUnauthenticate = reason
      this.defaultReasonUnauthenticate = true
      this.customModalUnauthenticate = true
    },

    openRefuseSenderDomainModal() {
      this.statePopUpRefuseSenderDomain = true
    },

    openUnauthenticateSenderDomainModal() {
      this.statePopUpUnauthenticateSenderDomain = true
    },

    submitAuthentication(requestingOrganizationId, senderRequestId) {
      this.buttonAuthenticationClicked = true
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .submitDnsValidate(organizationId, {
          organizationId: requestingOrganizationId,
          senderId: senderRequestId,
        })
        .then(() => {})
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.Message || 'Erro',
          })
        })
        .finally(() => {
          this.domainValue = ''
          this.domainNameHost = ''
          this.buttonAuthenticationClicked = false
          this.onTableChange()
        })
    },

    formatDate(date) {
      return date ? dateTimeFormatString(date) : ''
    },

    headerHandle() {
      return [
        {
          key: 'select',
          label: '',
          _classes: 'hidde',
          _style: 'width:50px',
        },
        { key: 'domainSender', label: this.$t('general.table.header.domain') },
        { key: 'requestingUserName', label: this.$t('general.table.header.requestedBy') },
        { key: 'organizationSender.isActive', label: this.$t('general.table.header.domainStatus') },
        { key: 'answerName', label: this.$t('general.table.header.answeredBy') },
        { key: 'organizationSender.statusId', label: this.$t('general.table.header.orderStatus') },
        {
          key: 'showDetails',
          label: '',
          _classes: 'hidde',
          _style: 'width:150px',
        },
      ]
    },

    mountItemsTable(arr) {
      return arr.reduce((acc, cur, index) => {
        acc.push({
          ...cur,
          _toggled: index == this.indexItemOpened ?? this.indexItemOpened != null ? true : false,
          index: index,
          _classes: [cur._selected ? 'table-selected' : null],
        })
        return acc
      }, [])
    },

    getData(data, loading = true) {
      this.loading = loading

      if (this.peding) {
        return
      }

      this.peding = true
      let organizationId = this.$store.state.auth.organizationId

      services
        .getSendersDomain(organizationId, { params: data })
        .then((senders) => {
          // this.pages = senders.data.data.pagination.totalPages / ;
          this.pages = Math.ceil(senders.data.data.pagination.totalRecords / 10)
          this.pagination = senders.data.data.pagination
          this.totalPendings = senders.data.data.totalPending
          this.totalRecords = senders.data.data.pagination.totalRecords
          this.activePage = senders.data.data.pagination.currentPage
          this.headers = this.headerHandle()
          this.loadedItems = this.mountItemsTable(senders.data.data.senderRequests)
        })
        .catch(() => {
          this.loadedItems = []
        })
        .finally(() => {
          this.loading = false
          this.loadingGetList = false
          this.peding = false
        })
    },

    onTableChange(loading = true) {
      this.getData(
        {
          page: this.activePage,
          count: this.itemsPerPage,
          Domain: this.tableFilterValue,
          SenderStatusId: this.SenderStatusId,
          OrganizationStatusId: this.OrganizationStatusId,
        },
        loading,
      )
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    check(item) {
      this.$set(this.loadedItems[item.index], '_selected', !this.loadedItems[item.index]._selected)
      this.itemsListSelected = item.domainSenderRequestId

      // Condições de exibição para contas do tipo Sendit
      // 1 == pedding
      if (this.isSendit && item.statusId == 1) {
        // this.showApproveRefuse = false
      } else {
        // this.showApproveRefuse = false
      }

      this.$store.dispatch(
        'senders/setIdSender',
        //item.organizationDomainSender.id
        item.organizationDomainSender.organizationDomainSenderId,
      )
    },

    isApprovedSender(id) {
      return this.loadedItems.filter((item) => item.domainSenderRequestId == id)[0].statusId == 2 //approved
    },

    deleteItemsSelected() {
      this.messages = []

      // if (!this.isApprovedSender(this.itemsListSelected)) {
      //   this.messages.push({
      //     status: 'warning',
      //     text: 'You can delete only approved senders',
      //   })
      //   return
      // }
      let organizationId = this.$store.state.auth.organizationId

      services
        .deleteSenderDomain(organizationId, this.itemsListSelected)
        .then(({ data }) => {
          this.onTableChange()

          this.messages.push({
            status: 'success',
            text: data.message ? data.message : 'selected items have been deleted',
          })

          setTimeout(() => {
            this.itemsListSelected = null
          }, 1000)
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message || response.data.Message,
          })
        })
    },

    statusOrder(position) {
      const positions = {
        1: this.$t('sender.domainSender.domainSenderList.status.peding-configuration'),
        2: this.$t('sender.domainSender.domainSenderList.status.pending-verification'),
        3: this.$t('sender.domainSender.domainSenderList.status.authenticated'),
        4: this.$t('sender.domainSender.domainSenderList.status.unauthenticate'),
        5: this.$t('sender.domainSender.domainSenderList.status.authenticated'),
        6: this.$t('sender.domainSender.domainSenderList.status.unauthenticate'),
      }

      return positions[position] || positions.default
    },

    statusOrderClass(position) {
      const positions = {
        1: 'pending',
        2: 'pending',
        3: 'approved',
        4: 'refused',
        5: 'approved',
        6: 'refused',
      }

      return positions[position] || positions.default
    },

    statusOrderDoamin(position) {
      return position ? 'approved' : 'pending'
    },

    statusOrganization(isActive) {
      return isActive ? this.$t('sender.domainSender.status.active') : this.$t('sender.domainSender.status.inactive')
    },

    chooseFilterBy(item) {
      this.SenderStatusId = null
      this.OrganizationStatusId = null

      if (item === 'all') {
        return
      }

      this[item.column] = item.value
    },

    toggleDetails(item, index) {
      this.$set(this.loadedItems[index], '_toggled', !item._toggled)
      this.indexItemOpened = !item._toggled ? index : null

      this.collapseDuration = 300
      this.$nextTick(() => {
        this.collapseDuration = 0
      })
    },

    approveOrReprove(obj) {
      this.messages = []
      this.loadingSenderRequest = true
      try {
        let item = this.loadedItems.find((item) => item.domainSenderRequestId === this.itemsListSelected)
        let organizationId = this.$store.state.auth.organizationId

        services
          .approveorrefuse(organizationId, {
            senderRequestId: item.domainSenderRequestId,
            domainSender: item.domainSender,
            status: obj.status,
            reasonText: obj.reasonText,
            value: obj.reasonText,
            nameHost: obj.reasonText,
          })
          .then(() => {
            this.showApproveRefuse = false
            this.onTableChange()
          })
          .catch((error) => {
            this.messages.push({
              status: 'danger',
              text: error.response.data.message,
            })
          })
          .finally(() => (this.loadingSenderRequest = false))
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || '',
        })
      }
    },

    organizationId() {
      this.$store.dispatch('senders/organizationUsers', this.$store.state.auth.organizationId)
    },

    setTypeSender() {
      const nameRoute = this.$route.name.split('-')[1]
      const type = nameRoute.charAt(0).toUpperCase() + nameRoute.slice(1)
      this.$store.dispatch('senders/setTypeSender', type)
    },

    navigateToDomainHelpDocs() {
      window.open(`${this.$configs.VUE_APP_DOCS_URL}docs/arpoone-api/getting-started/authentication-email-domain`, '_blank')
    },
  },
}
</script>
<style scoped lang="scss">
.pending {
  color: var(--warning);
}

#domainValue {
  /*background-color: #edeff1 !important;
  border-bottom: 1px solid #d1d4da;*/
}

.active,
.approved {
  color: var(--success);
}

.refused {
  color: var(--danger);
}

.listItem__download {
  cursor: pointer;
}

.listItem__name {
  flex: 0 0 20%;
  min-width: 250px;
}

.listItem__numbers {
  font-size: $font-size-xs;
  position: relative;
}

.listItem__detail {
  flex-wrap: wrap;
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
